// extracted by mini-css-extract-plugin
export default {"mainGray":"#ebeef0","line":"line_line__WE5yp"};